import type { PropsWithChildren, ReactNode } from 'react';
import { Component } from 'react';

import { captureException } from '../monitoring';

interface AppErrorBoundaryState {
  readonly failed: boolean;
}

export class AppErrorBoundary extends Component<PropsWithChildren, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { failed: true };
  }

  componentDidCatch(error: Error): void {
    captureException(error, 'react');
  }

  render(): ReactNode {
    if (!this.state.failed) {
      return this.props.children;
    }
    return (
      <main className="fatal-error" role="alert">
        <span aria-hidden="true">◇</span>
        <h1>行动界面发生异常</h1>
        <p>本地存档不会被清除。刷新页面即可重新加载当前版本。</p>
        <button type="button" onClick={() => window.location.reload()}>
          重新加载
        </button>
      </main>
    );
  }
}
